// PHONE_NUMBER_REGEX follows the Nkom`s norwegian numberplan
export const PHONE_NUMBER_REGEX_STRICT = /^(?:\+47|0047)?(?:[23-9]\d{7})$/;
export const PHONE_NUMBER_REGEX_ALLOW_SPACE = /^(?:\+47\s?|0047\s?)?[2-9](?:\s?\d){7}$/;
// POSTAL_CODE_REGEX see https://www.bring.no/tjenester/adressetjenester/postnummer/mer-om-postnummer
export const POSTAL_CODE_REGEX = /^\d{4}$/;
